import { render, staticRenderFns } from "./profile-orders.vue?vue&type=template&id=65a52cf5&scoped=true&"
import script from "./profile-orders.vue?vue&type=script&lang=js&"
export * from "./profile-orders.vue?vue&type=script&lang=js&"
import style0 from "./profile-orders.vue?vue&type=style&index=0&id=65a52cf5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a52cf5",
  null
  
)

export default component.exports